import { useState } from 'react'
import { useStore } from 'react-redux'
import { toast } from 'react-toastify'
import { orderDetailsRequested, mutationRequested, mutationSucceeded, mutationFailed } from '../actions/order'

import MutationApi from '../remote/mutationApi'

const resolveErrorMessage = (messages) => {
  return messages?.find?.(message => !!message)
}

const useUpdatePayment = () => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [failed, setFailed] = useState(false)
  const store = useStore()

  const executeRequest = ({ orderId, paymentId, tip, amountInCents, shortDescription, signature }) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    let payload = {
      orderId,
      tip,
      amountInCents,
      shortDescription,
      signature,
      paymentUuid: paymentId,
    }

    store.dispatch(mutationRequested({ orderId, mutationType: "updatePayment" }))
    MutationApi.updatePayment(payload).then((result) => {
      store.dispatch(mutationSucceeded({ orderId }))
      const applied = result?.data?.orderMutations?.[0]?.applied
      setLoading(false)

      if (applied) {
        setSuccess(true)
        setFailed(false)

        store.dispatch(orderDetailsRequested(orderId))
      } else {
        setSuccess(false)
        setFailed(true)
      }
    }).catch((err) => {
      setLoading(false)
      setSuccess(false)
      setFailed(true)

      store.dispatch(mutationFailed({ orderId }))
      const errorMessage = resolveErrorMessage([
        err?.response?.data?.errorMessage,
        'There was an error updating the payment',
      ])
      toast.error(errorMessage)
    })
  }

  return [executeRequest, { loading, success, failed }]
}

export default useUpdatePayment
